import React, { useEffect, useState } from 'react'
import { useRazorpay } from 'react-razorpay'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getCheckout } from '../Redux/ActionCreator/CheckoutActionCreator';
import { getCart } from '../Redux/ActionCreator/CartActionCreator';

export default function Payment() {
    let [cart, setCart] = useState([])
    var [checkout, setCheckout] = useState({})
    var [user, setUser] = useState({})
    const { Razorpay } = useRazorpay();
    var navigate = useNavigate();
    var { _id } = useParams()
    var dispatch = useDispatch();
    var allCheckouts = useSelector(state => state.CheckoutStateData)
    let CartStateData = useSelector(state => state.CartStateData)

    async function getData() {
        dispatch(getCheckout())
        var result
        if (_id == "-1") {
            result = allCheckouts[0]
        }
        else
            result = allCheckouts.find((item) => item._id === _id)

        setCheckout(result)
        setUser(result?.user)
    }

    useEffect(() => {
        dispatch(getCart())
        if (CartStateData.length) {
            let data = CartStateData
            setCart(data);
        }
        else
            setCart([])
    }, [])

    useEffect(() => {
        getData()
    }, [allCheckouts.length])

    const initPayment = (data) => {
        const options = {
            key: "rzp_test_kJFCr5jnzPYy9s",
            amount: data?.amount,
            currency: "INR",
            order_id: data?._id,
            "prefill": {
                "name": user?.name,
                "email": user?.email,
                "contact": user?.phone,
            },
            handler: async (response) => {
                try {
                    var item = {
                        razorpay_payment_id: response.razorpay_payment_id,
                        checkid: checkout._id
                    }
                    var response = await fetch("/api/checkout/verify", {
                        method: "post",
                        headers: {
                            "Content-Type": "application/json",
                            "authorization": localStorage.getItem("token")
                        },
                        body: JSON.stringify(item)
                    });
                    response = await response.json()
                    if (response.result === "Done") {
                        navigate('/confirmation')
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            theme: {
                color: "#3399cc",
            }
        };
        const rzp1 = new Razorpay(options)
        rzp1.open();
    }

    const handlePayment = async () => {
        try {
            var response = await fetch("/api/checkout/orders", {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token")

                },
                body: JSON.stringify({ amount: checkout.total })
            });
            response = await response.json()
            initPayment(response?.data);

        } catch (error) {
            console.log(error);
        }
    };

    return (
        <section className='login_box_area section_gap'>
            <div className='container my-3 text-center'>
                <div className="testimonial-item img-border-radius shadow-sm bg-white p-4 mb-3">
                    {
                        cart.length ?
                            cart.map((item, index) => {
                                return <div key={index} className="row">
                                    <div className="col-md-4">
                                        <Link to={`/product/${item?.product?._id}`}><img src={`/${item.product?.pic}`} height={150} width="50%" alt="" /></Link>
                                    </div>
                                    <div className='col-md-8'>
                                        <div className='d-flex justify-content-between'>
                                            <div className='mt-2'><p>{item.product?.name.slice(0, 20) + "..."}<span className='border rounded-pill px-2 mx-2' style={{ fontSize: "12px" }}>Brand:{item.product?.brand?.name}</span></p>
                                                <p className='extra' style={{ fontSize: "14px" }}>{item.product?.maincategory?.name}, {item.product?.color}, {item.product?.size}</p>
                                                <p className='extra'><del>&#8377; {item.product?.basePrice}</del> &#8377; {item.product?.finalPrice}<sup className='text-success'> {item.product?.discount}% Off</sup></p>
                                            </div>

                                            <div className='mt-2 total-price'>
                                                <span><strong>Total_Price</strong><p><strong>&#8377;</strong> {item.total}</p></span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }) : ""
                    }
                </div>
                <div>
                    {
                        checkout ? <button onClick={handlePayment} className='btn btn-info m-auto'>
                            Pay ( &#8377; {checkout.total} ) with Razorpay
                        </button> : ""
                    }
                </div>
            </div>
        </section>
    )
}


